import { render, staticRenderFns } from "./noFooter.vue?vue&type=template&id=6a6fccb4&"
import script from "./noFooter.vue?vue&type=script&setup=true&lang=js&"
export * from "./noFooter.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./noFooter.vue?vue&type=style&index=0&id=6a6fccb4&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheHeader: require('/var/www/app/components/TheHeader.vue').default})
